import { apiRoutes } from 'routes';
import FetchHelpers from 'utils/FetchHelpers';

export default {
  current() {
    const path = apiRoutes.currentUserPath();
    return FetchHelpers.get(path);
  },
};
